export default __webpack_public_path__ + "static/media/126.65bc6b79.webp";